<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="로그인 이력 관리" :IsUseEditorBox="true" device="web">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                :menu="true"
                :dateOnly="true"
                :allowMaxDate="searchMaxDate"
                @getDate="setSearchDate($event, 'start')"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1 mx-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                :menu="true"
                :dateOnly="true"
                :allowMinDate="searchMinDate"
                @getDate="setSearchDate($event, 'end')"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" lg="12" class="pa-0">
                <DxDataGrid
                  id="loginHistoryDataGrid"
                  class="layout-col-height00"
                  width="100%"
                  :ref="dxDataGridRef"
                  :selection="{ mode: 'single' }"
                  :data-source="datasource"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  key-expr="id"
                >
                  <!-- <DxEditing
                    mode="batch"
                    :allow-updating="false"
                    :select-text-on-edit-start="false"
                  />-->
                  <!-- 
                  <DxSelection
                    :select-all-mode="allMode"
                    show-check-boxes-mode="always"
                    mode="multiple"
                  />-->
                  <DxColumn
                    data-field="clntNm"
                    caption="고객사"
                    width="240px"
                    data-type="string"
                    alignment="center"
                    :allow-editing="false"
                  />
                  <DxColumn
                    data-field="userCd"
                    caption="유저코드"
                    width="170px"
                    data-type="string"
                    alignment="center"
                    :allow-editing="false"
                  />
                  <DxColumn
                    data-field="userNm"
                    caption="성명"
                    width="150px"
                    data-type="string"
                    alignment="center"
                    :allow-editing="false"
                  />
                  <DxColumn
                    data-field="formattedLoginDate"
                    caption="접속일시"
                    width="200px"
                    data-type="string"
                    alignment="center"
                    :allow-editing="false"
                  />
                  <DxColumn
                    data-field="loginIp"
                    caption="IP"
                    width="170px"
                    data-type="string"
                    alignment="center"
                    :allow-editing="false"
                  />
                  <DxColumn
                    data-field="loginDevice"
                    caption="접속장치"
                    data-type="string"
                    alignment="center"
                    cell-template="loginDeviceTemplate"
                    :allow-editing="false"
                  />
                  <template #loginDeviceTemplate="{ data: cellInfo }">
                    <div v-if="cellInfo.data.loginDevice == 'W'">{{ 'WEB' }}</div>
                    <div v-else-if="cellInfo.data.loginDevice == 'M'">{{ 'MOBILE' }}</div>
                  </template>
                  <DxColumn
                    data-field="loginSuccessYn"
                    caption="접속성공 여부"
                    data-type="string"
                    alignment="center"
                    cell-template="loginStatusTemplate"
                    :allow-editing="false"
                  />
                  <template #loginStatusTemplate="{ data: cellInfo }">
                    <div v-if="cellInfo.data.loginSuccessYn == 'Y'" style="color:blue;">{{ '성공' }}</div>
                    <div
                      v-else-if="cellInfo.data.loginSuccessYn == 'N'"
                      style="color:red;"
                    >{{ '실패' }}</div>
                  </template>
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right
        :useBtnList="buttonUseList"
        :reportItems="reportItems"
        @btnSearch="btnSearch(true)"
        @btnPrint="btnPrint"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { Workbook } from 'exceljs'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'
import { exportDataGrid as exportPdf } from 'devextreme/pdf_exporter'
import malgun from '@/assets/font/malgun.ttf'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getLoginHistory } from '@/api/setting/loginHistoryManage.js'
import { downloadFile } from '@/api/baseManage/fileUpload'
import { getPreMonth } from '@/utils/common.js'
export default {
  mixins: [baseview, BaseDataGrid],
  name: 'LoginHistoryManage',
  components: {
    'i-date-time-picker': IDateTimePicker
  },
  data() {
    return {
      dxDataGridRef: 'loginHistoryDataGrid',
      datasource: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnPrint' //출력
      ],
      reportItems: [
        { role: 'pdf', title: 'PDF' },
        { role: 'xls', title: 'EXCEL' }
      ],
      allMode: 'allPages',
      startDate: getPreMonth(1), //디폴트 시작일
      endDate: getPreMonth(0),   //디폴트 종료일
      searchMinDate: getPreMonth(1),  //허용 가능한 최소 시작일
      searchMaxDate: getPreMonth(0),  //허용 가능한 최대 종료일
      searchStartDate: getPreMonth(3).replace(/[^0-9]/g, ''), //시작일(조회)
      searchEndDate: getPreMonth(-3).replace(/[^0-9]/g, '')   //종료일(조회)
    }
  },
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    // 조회 버튼
    btnSearch(isNotify) {
      let param = {
        searchStartDate: this.searchStartDate,
        searchEndDate: this.searchEndDate
      }
      this.openLoading()
      getLoginHistory(param, isNotify)
        .then(res => {
          this.datasource = res.list
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // 저장 버튼
    async btnPrint(type) {
      if (type == 'xls') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet('로그인 이력')

        exportExcel({
          component: this.GetDataGrid(this.dxDataGridRef),
          worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(
              new Blob([buffer], { type: 'application/octet-stream' }),
              `로그인이력(${this.dateFormat(this.searchStartDate)}~${this.dateFormat(this.searchEndDate)}).xlsx`
            )
          })
        })
      }

      if (type == 'pdf') {
        const doc = new jsPDF()
        doc.addFont(malgun, 'malgun', 'normal')

        exportPdf({
          jsPDFDocument: doc,
          component: this.GetDataGrid(this.dxDataGridRef),
          autoTableOptions: {
            styles: {
              font: 'malgun'
            }
          }
        }).then(() => {
          doc.save(`로그인 이력(${this.dateFormat(this.searchStartDate)}~${this.dateFormat(this.searchEndDate)}).pdf`)
        })
      }
    },
    ///////////////////////////////////////
    /*          dataGrid Event           */
    ///////////////////////////////////////

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    dateFormat(date) {
      let year = date.substring(0, 4)
      let month = date.substring(4, 6)
      let day = date.substring(6, 8)
      return `${year}.${month}.${day}`
    },
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
      this.btnSearch(true)
    }
  }
}
</script>
